import axios from "axios";
import apiURI from "./Api";

export default class FiscalService {
  async getFiscalStatus(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/user/fiscal/status`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postFiscalSave(token, fiscalDataJSON) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/user/fiscal/save`,
      data: fiscalDataJSON,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
